angular.module('picmonicng').controller('PathwaysTracksController', [
  '$scope',
  '$stateParams',
  '$browseStateParams',
  '$filter',
  'Pathways',
  '$location',
  'UserService',
  'MarketOptionsConfig',
  'MetaService',
  '$rootScope',
  'BrowseService',
  '$cookies',
  'MarketSelectorModalService',
  'LocalStorageService',
  '$modal',
  '$state',
  '$timeout',
  '$anchorScroll',
  'ReferralResource',
  'ReferralDataService',
  'MetatagResource',
  'SplitTestService',
  function (
    $scope,
    $stateParams,
    $browseStateParams,
    $filter,
    Pathways,
    $location,
    UserService,
    MarketOptionsConfig,
    MetaService,
    $rootScope,
    BrowseService,
    $cookies,
    MarketSelectorModalService,
    LocalStorageService,
    $modal,
    $state,
    $timeout,
    $anchorScroll,
    ReferralResource,
    ReferralDataService,
    MetatagResource
  ) {
    $scope.user = UserService.user;
    $scope.BrowseService = BrowseService;
    $scope.$anchorScroll = $anchorScroll;
    $anchorScroll.yOffset = 104;

    $scope.loadingPathway = true;
    $scope.loadingSubpathways = true;
    $scope.locationParams = $location.search();
    $scope.pathway = {};
    $scope.subpathways = [];
    $scope.dataChanged = false;
    $scope.openAllSubpathways = false;
    $scope.onBooks = false;
    $scope.ReferralDataService = ReferralDataService;
    $scope.metatags = {};
    $scope.user_count = window.pls_config.user_count;

    // Build breadcrumb urls
    var parts = $location.$$path.split('/');
    $scope.breadcrumbs = [$location.$$protocol + '://' + $location.$$host + $location.$$path];
    parts.splice(-3);
    $scope.breadcrumbs.unshift($location.$$protocol + '://' + $location.$$host + parts.join('/'));

    if (UserService.user.user_id && $state.current.name.indexOf('app.pathways') > -1) {
      var params = {
        market: $stateParams.market,
        curriculum: $stateParams.curriculum,
        pathway_id: $stateParams.pathway_id,
        scroll_to: $location.search().scroll_to,
      };
      $location.url(
        '/home' +
          '?browse=' +
          $state.current.name +
          '&browseParams=' +
          JSON.stringify(params) +
          '&browseOptions=' +
          JSON.stringify({ open: true })
      );
    }

    if (!UserService.user.user_id) {
      MetatagResource.get({ url: $location.$$path }, function (data) {
        $scope.metatags = data;

        if (data.h1) {
          $scope.replaceH1 = data.h1;
        }

        if (data.h2) {
          $scope.replaceH2 = data.h2;
        }

        if (data.title) {
          MetaService.replace('%PATHWAY%', data.title);
        } else {
          MetaService.replace('%PATHWAY%', 'Pathways');
        }

        if ($stateParams.register) {
          $scope.register(false);
        }
      });
    }

    if ($state.current.name.indexOf('books') > -1) {
      $scope.onBooks = true;
    }

    var localStorageBrowseService = LocalStorageService.extractItem('browse');

    if (!localStorageBrowseService && $stateParams.pathway_id) {
      $scope.openAllSubpathways = true;
    }

    // Load pathway from state params or API
    var pathway_slug = String(
      $browseStateParams.pathway_id ? $browseStateParams.pathway_id : $stateParams.pathway_id
    ).split('-');
    var pathway_id = pathway_slug[pathway_slug.length - 1];
    var market = MarketOptionsConfig.getMarketBySlug(
      $browseStateParams.market ? $browseStateParams.market : $stateParams.market
    );
    $scope.currentMarket = $scope.market = market;

    UserService.setCookieIfNotLoggedIn('role', 'Student');
    $scope.loadingPathway = true;
    $scope.pathway = Pathways.getv3({ pathway_id: pathway_id, market_id: market.id }, function () {
      if (!$scope.pathway.market_id) {
        $scope.pathway.market_id = market.id;
      }
      if (!BrowseService.browseOpen) {
        if ($scope.metatags.title) {
          MetaService.replace('%PATHWAY%', $scope.metatags.title);
        } else {
          MetaService.replace('%PATHWAY%', $scope.pathway.name);
        }

        MetaService.replace(
          '%DESCRIPTION%',
          'Learn ' +
            $scope.pathway.name +
            " faster and easier with Picmonic's unforgettable images and stories! Picmonic is research proven to increase your memory retention and test scores. Start learning today for free!"
        );
        MetaService.replace('%MARKET%', market.name);
      }
      $scope.loadingPathway = false;
    });

    // Handle URL parameter scroll-to behavior
    var scrollToPathway = $location.search().pathway_id || $browseStateParams.scroll_to;
    var scrollToTrack = $location.search().track_id;
    var scrollToContent = $location.search().scroll_to;
    if (scrollToTrack) {
      $scope.scrollToType = 'track';
      $scope.scrollToId = scrollToTrack;
    } else if (scrollToPathway) {
      $scope.scrollToType = 'subpathway';
      $scope.scrollToId = scrollToPathway;
    } else if (scrollToContent == 'content') {
      $anchorScroll('pathways-block-section');
    }

    // Load subpathways
    $scope.getSubPathways = function () {
      $scope.loadingSubpathways = true;
      Pathways.queryv3(
        {
          pathway_id: pathway_id,
          resource: 'tracks',
        },
        function (pathways) {
          $scope.track_id = $scope.locationParams.track_id;

          var parentPathways = $filter('orderBy')($filter('filter')(pathways, { parent_id: pathway_id }), 'sort_order');

          var count = 1;
          for (var a in parentPathways) {
            parentPathways[a].toggled = true;
            var parentPathway = parentPathways[a];
            var parentPathwayTracks = $filter('orderBy')(parentPathway.tracks, 'sort_order');

            if ($scope.openAllSubpathways) {
              BrowseService.visibleSubPathways.push(parentPathway.pathway_id);
            }

            for (var b in parentPathwayTracks) {
              if (!parentPathway.suggested_flag) {
                parentPathwayTracks[b].index = count;
                count++;
              }
            }

            var subPathways = $filter('orderBy')(
              $filter('filter')(pathways, {
                parent_id: parentPathway.pathway_id,
              }),
              'sort_order'
            );

            for (var c in subPathways) {
              var subPathway = subPathways[c];
              var subPathwayTracks = $filter('orderBy')(
                $filter('filter')(subPathway.tracks, { hidden: 0 }),
                'sort_order'
              );

              for (var d in subPathwayTracks) {
                subPathwayTracks[d].index = count;
                count++;
              }
            }
          }
          $scope.subpathways = pathways;
          $scope.loadingSubpathways = false;

          $timeout(function () {
            if (window.innerWidth < 480) {
              var lastScrollTop = 0;
              $('.browse__content').bind('touchmove', function (event) {
                if ($(this).scrollTop() > lastScrollTop) {
                  if ($rootScope.bodyClass.indexOf('nav-browse-hidden-mobile') === -1 && !BrowseService.moreMenuOpen) {
                    $scope.$apply(function () {
                      $rootScope.bodyClass.push('nav-browse-hidden-mobile');
                    });
                  }
                } else if ($(this).scrollTop() < lastScrollTop) {
                  if ($rootScope.bodyClass.indexOf('nav-browse-hidden-mobile') !== -1) {
                    $scope.$apply(function () {
                      $rootScope.bodyClass.splice($rootScope.bodyClass.indexOf('nav-browse-hidden-mobile'), 1);
                    });
                  }
                }

                lastScrollTop = $(this).scrollTop();
              });
            }
          }, 1000);
        },
        function () {
          $state.transitionTo('app.404');
        }
      );
    };
    $scope.getSubPathways();

    var onChange = function (event, data) {
      if (data.action === 'quiz_attempt') {
        $scope.getSubPathways();
      }
    };
    $scope.$on('cardDataChanged', onChange);

    $scope.register = function () {
      UserService.showRegisterModal(false, null, null, null, $scope.currentMarket.id);
    };
  },
]);
